import React, { Component } from "react";
import { connect } from 'react-redux';
import { View, ScrollView, TouchableOpacity, StyleSheet } from "react-native";
import {Header,TaskSuccess,CheckComponent,Form,Label,Videoplayer} from "../../../components/SharedComponents";
import actions from "../../../actions";
import { global, colors } from "../../../shared/const";
import localize from "../../../shared/localize";

const { getUserFamilyGroup, finishDailyTask, getDailyTask }=actions

class DailyTask extends Component {

    static navigationOptions = () => {
        return {
            title: localize.daily_task
        }
    }

    isChecked = null;
    constructor(props) {
        super(props);
        this.state = {
            isChecked: null,
            status: false,
            isbtnDisable: true
        }
    }

    componentDidMount = () => {
        this.props.getDailyTask();
    }

    _videoProgress = (currentTime) => {
        if (currentTime >= 5)
            this.setState({ isbtnDisable: false });
    }

    _checkStatus = (data, status) => {
        if (status === 1) return;
        return this.setState({ isChecked: data, isbtnDisable: false });
    }

    _completedTask = async () => {
        let task_id = this.state.isChecked;
        if (!task_id) task_id = task_id = this.isChecked
        const res = await this.props.finishDailyTask(task_id);
        if (res) return this.setState({ status: true });
    }

    _taskDone = async () => {
        const group = await this.props.getUserFamilyGroup();
        const { group_chat_id, group_chat_name } = group;
        if (group_chat_id !== "" && group_chat_name !== "") {
            let navigationState = { groupId: group_chat_id, name: group_chat_name }
            if (global.isNative)
                return this.props.navigation.navigate("groupChat", navigationState);
            return this.props.history.push({
                pathname: "/chat/conversation",
                state: navigationState,
                search: `?groupId=${group_chat_id}&name=${group_chat_name}`
            });
        }
        if (global.isNative)
            return this.props.navigation.navigate("dashboard");
        this.props.history.push("/dashboard");
    }

    renderItem = (item) => {
        const { isChecked } = this.state;
        if (item.video_url !== "") {
            this.isChecked = item.id;
            let uri = `https://${global.main_server + item.video_url}`;
            return (
                <Videoplayer
                    src={uri}
                    poster={global.MAKEURL(item.video_thumbnail)}
                    key={item.id}
                    handleTimer={this._videoProgress}
                />
            )
        }

        return (
            <View style={{ flexDirection: "row" }} key={item.id}>
                <CheckComponent
                    checked={Number(item.task_status) === 1 ? true : item.id === isChecked}
                    onPress={() => this._checkStatus(item.id, Number(item.task_status))}
                    disabled={Number(item.task_status) === 1 ? true : false}
                />
                <TouchableOpacity
                    onPress={() => this._checkStatus(item.id, Number(item.task_status))}
                    activeOpacity={0.8}
                    style={styles.task_item}
                >
                    <Label.PrimarySubtitle
                        color={Number(item.task_status) === 1 ? colors.gray : colors.indigo}
                    >
                        {item.content}
                    </Label.PrimarySubtitle>
                </TouchableOpacity>
            </View>
        )
    }

    render() {
        const { daily_task } = this.props

        return (
            <View style={styles.root}>
                <Header title={localize.daily_task} goBack={() => this.props.history.goBack()} hidden={global.isNative} />
                <ScrollView bounces={false}>
                    <View style={styles.container}>
                        {!this.state.status ? (
                            <>
                                <Label.PrimaryCaption align="center">
                                    {localize.your_task}
                                </Label.PrimaryCaption>
                                <Label.PrimaryTitle>
                                    {daily_task && daily_task.content}
                                </Label.PrimaryTitle>
                                <View style={{ height: 40 }} />
                                {daily_task && daily_task.task && daily_task.task.map(this.renderItem)}
                                <View style={{ height: 40 }} />
                                <Form.Button
                                    title={localize.i_did_this}
                                    disabled={this.state.isbtnDisable}
                                    onPress={this._completedTask}
                                />
                                <View style={{ height: 40 }} />
                                <Label.SubtitleItalic>
                                    {localize.your_activity_will_be_shared}
                                </Label.SubtitleItalic>
                            </>
                        ) : (
                                <TaskSuccess
                                    title={localize.thank_you_for_completing_task}
                                    point={localize.points_14}
                                    buttonPress={this._taskDone}
                                />
                            )}
                    </View>
                </ScrollView>
            </View>
        )
    };
}

const mapStateToProps = ({ main }) => {
    return {
        daily_task: main.daily_task
    }
}
const mapDispatch = (dispatch) => {
    return {
        getDailyTask: () => dispatch(getDailyTask()),
        getUserFamilyGroup: () => dispatch(getUserFamilyGroup()),
        finishDailyTask: (task_id) => dispatch(finishDailyTask(task_id)),
    }
}
export default connect(mapStateToProps, mapDispatch)(DailyTask);

const styles = StyleSheet.create({
    root: {
        flex: 1,
        backgroundColor: colors.app_background
    },
    container: {
        padding: 15
    },
    task_item: {
        flex: 1,
        paddingLeft: 10
    }
})